import React from 'react';
import { Text } from '@televet/kibble-ui/build/components/Text';

const ErrorInstructionComponent = ({ errorText }: { errorText: string }): JSX.Element => {
  return (
    <Text as="p" pt={2} variant="danger" size="sm" fontWeight="bold">
      {errorText}
    </Text>
  );
};

export default ErrorInstructionComponent;
